import { Button } from '@/components/shadcn/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/shadcn/dropdown-menu'
// import { ConfirmDialog } from '@/components/ui/ConfirmDialog'
import { RestSchemas } from '@/contexts/QueryProvider'
import { IconMenuOutline } from '@icons/IconMenuOutline'
import { MaintainProjectTeamForm } from '../../Forms/MaintainProjectTeamForm'
import { OrgTeamForm } from '../../Forms/OrgTeamForm'
import { MaintainSupportTeamRolesForm } from '../../Forms/MaintainSupportTeamRolesForm'

type MessagesSubscriptionsOrganisationTeam = RestSchemas['Messages.Subscriptions.OrganisationTeam']

export function RowActionsMenu({ team }: { team: MessagesSubscriptionsOrganisationTeam }) {
  return (
    <>
      <DropdownMenu
        onOpenChange={(open) => {
          // This is necessary to maintain the open state when we want to keep it open
          if (!open) {
            // Check if we need to prevent closing
            // This is a placeholder for custom logic you might need
            // We'll use other mechanisms to prevent closing on item click
          }
        }}
      >
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="size-8">
            <IconMenuOutline size={16} />
            <span className="sr-only">Open menu</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          onCloseAutoFocus={(e) => {
            // Prevent focus returning to trigger which can close the menu
            e.preventDefault()
          }}
        >
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          <OrgTeamForm
            selectedTeam={team}
            sheetTitle={`${team.name} > Edit team`}
            sheetDescription="Edit the details of the team."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Edit team</DropdownMenuItem>}
          />
          <OrgTeamForm
            delete
            selectedTeam={team}
            sheetTitle={`${team.name} > Delete team`}
            sheetDescription="Delete the team"
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Delete team</DropdownMenuItem>}
          />
          <MaintainProjectTeamForm
            selectedProjectTeam={team}
            sheetTitle={`${team.name} > Maintain team members`}
            sheetDescription="Edit the members of the team."
            sheetTrigger={
              <DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain team members</DropdownMenuItem>
            }
          />
          <MaintainSupportTeamRolesForm
            selectedTeam={team}
            sheetTitle={`${team.name} > Maintain support team roles`}
            sheetDescription="Edit the roles of the team."
            sheetTrigger={<DropdownMenuItem onSelect={(e) => e.preventDefault()}>Maintain team roles</DropdownMenuItem>}
          />
        </DropdownMenuContent>
      </DropdownMenu>
    </>
  )
}
